import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';

import { useLoadInquiriesList } from 'api/CompeonReverseApi/operation/queryHooks';
import { ConfigController } from 'config/ConfigController';
import paths from 'constants/paths';
import { useInquiriesListContext } from 'modules/InquiriesListProvider';
import { InquiryType } from 'modules/Inquiry/Inquiry.type';
import { getInquiryFlowStartUrl } from 'store/config/selectors';
import { setInquiryType } from 'store/inquiryProcess/actions';

const InquiryFormDraftInitializer = () => {
  const { tableOptions } = useInquiriesListContext();
  const { data, isSuccess: isInitialized } = useLoadInquiriesList({
    variables: { options: tableOptions },
  });
  const { id: inquiryDraftId } = useParams();
  const startPoint = useSelector(getInquiryFlowStartUrl);

  const formType =
    data.inquiries.find((inquiry) => inquiry.id === inquiryDraftId).formType ?? InquiryType.default;
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setInquiryType(formType));
    ConfigController.form.selectInquiryType(formType, true);
  }, [dispatch, formType]);

  if (!isInitialized) {
    return null;
  }

  const draftStartingPoints = {
    [InquiryType.default]: startPoint,
    [InquiryType.leaseplan]: paths.customer.inquiryDetails.edit.contractDetails.replace(
      ':id',
      inquiryDraftId,
    ),
  };

  return <Redirect to={draftStartingPoints[formType] ?? startPoint} />;
};

export default InquiryFormDraftInitializer;
